// extracted by mini-css-extract-plugin
export default {"section":"OurTeam_section__QkCMu","container":"OurTeam_container__9d8C3","img":"OurTeam_img__s1dY2","text":"OurTeam_text__g+lKu","shapeRight":"OurTeam_shapeRight__WlZfi"};